import * as React from 'react'
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form'
import styled from 'styled-components'

import { BaseFormField } from './formFields/BaseFormField'
import { encodeFormFieldKey, useGeckoForm } from './formHelpers'
import { FormFieldsByUniqueID, SimpleFormField } from './formTypes'

export const StyledForm = styled.form<{
  $columns: number
}>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
  flex-direction: column;
  gap: 0.25rem 1rem;
  margin-bottom: 1rem;
  flex-grow: 1;
  width: 100%;
`

export interface FormComponentProps {
  onSubmit: SubmitHandler<SimpleFormField>
  formFieldsByUniqueID: FormFieldsByUniqueID[]
  numberOfColumns?: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propForm?: UseFormReturn<SimpleFormField, any, FieldValues>
}

export const GeckoForm = React.forwardRef<HTMLFormElement, FormComponentProps>(
  ({ formFieldsByUniqueID, onSubmit, numberOfColumns = 1, propForm }, ref) => {
    const useForm = useGeckoForm(formFieldsByUniqueID)
    const form = propForm ?? useForm

    return (
      <>
        <FormProvider {...form}>
          <StyledForm
            onSubmit={form.handleSubmit(onSubmit)}
            ref={ref}
            $columns={numberOfColumns}>
            {formFieldsByUniqueID.map((formFieldsByUniqueID) =>
              formFieldsByUniqueID.formFields.map((formField) => (
                <BaseFormField
                  key={`${formField.dataKey}#${encodeFormFieldKey(formFieldsByUniqueID.uniqueID)}`}
                  formField={formField}
                  formItemKey={`${formField.dataKey}#${encodeFormFieldKey(formFieldsByUniqueID.uniqueID)}`}
                  formControl={form.control}
                  formErrors={form.formState.errors}
                  formTrigger={form.trigger}
                  formSetValue={form.setValue}
                />
              ))
            )}
          </StyledForm>
        </FormProvider>
      </>
    )
  }
)

GeckoForm.displayName = 'GeckoForm'
